import { useTranslation } from "react-i18next";
import { Button } from "@/components/shadcn/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/shadcn/tooltip";
import { Download } from "lucide-react";

interface Props {
  onClick?: () => void
}

export function ExportTimeTrackingButton({ onClick }: Props) {
  const { t } = useTranslation('service-modules-timetracking')
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="h-9 w-9"
            onClick={onClick}
          >
            <Download className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('timetracking.exportTooltip')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
